import React from "react";

import ImportExportMenu from "Components/Common/DataImport/ImportExportMenu";
import { DataImportConfig } from "Components/Common/DataImport/dataImportFields";
import {
  exportOrganizationTypesToCSV,
  importOrganizationType,
} from "common/services/contractors.service";

const importConfig: DataImportConfig = {
  title: "Organization Types",
  entityLabel: "organization type",
  icon: "ri-building-line",
  templateFile: "organization_types_import_template.csv",
  importFn: importOrganizationType,
  fields: [
    {
      key: "name",
      label: "Name",
      required: true,
      hint: "Must be unique across organization types",
    },
    {
      key: "category",
      label: "Category",
      hint: "Must match an existing organization type",
    },
  ],
};

/** Import/export menu for the organization types table. */
const Import = ({ apiParams }: { apiParams?: any }) => (
  <ImportExportMenu
    resource="organization-type"
    config={importConfig}
    exportFn={exportOrganizationTypesToCSV}
    exportFileName="Organization_Types_Export.csv"
    apiParams={apiParams}
  />
);

export default Import;
